import { Card, Col, Row, Typography } from 'antd';
import { CreditCardOutlined, FallOutlined, RiseOutlined } from '@ant-design/icons';
import React from 'react';
import Paragraph from 'antd/es/typography/Paragraph';
import Title from 'antd/lib/typography/Title';
import ActiveAccountsChart from './charts/active-accounts-chart';
import InactiveAccountsChart from './charts/inactive-accounts-chart';
import NewCardsChart from './charts/new-cards-chart';

const DataMiddleCards = ({ isEsor, loading, platformData }: { isEsor?: boolean | false, loading: boolean, platformData: any }) => {

  return isEsor ? (
      <Col span={8}>
        <Col span={24} style={{ paddingLeft: '0px' }}>
          <Card
            loading={loading}
            style={{
              paddingBottom: '10px !important',
              maxHeight: '180px',
              borderRadius: '16px'
            }}>
            <Row gutter={24}>
              <Col span={14}>
                <Paragraph style={{ fontSize: '16px' }} type="secondary">Cards nuevas</Paragraph>
                <Title level={2} style={{ marginLeft: '0px', marginTop: '0px' }}>{ platformData?.cards?.created || 0 }</Title>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'start', width: '100%' }}>
                  <CreditCardOutlined
                    style={{
                      fontSize: '25px',
                      width: '40px',
                      height: '40px',
                      justifyContent: 'center',
                      color: 'rgb(105, 80, 232)',
                      backgroundColor: 'rgba(105, 80, 232, 0.1)',
                      borderRadius: '50%',
                    }} />
                  <Typography.Text style={{ paddingLeft: '5px' }}>
                    + 23%
                  </Typography.Text>
                </div>
              </Col>
              <Col span={10}>
                <NewCardsChart
                  totalCards={ platformData?.cards?.total }
                  createdCards={ platformData?.cards?.created }
                />
              </Col>
            </Row>
          </Card>
        </Col>

        <Col span={24} style={{ paddingTop: '20px', paddingBottom: '20px', paddingLeft: '0px' }}>
          <Card
            loading={loading}
            style={{
              paddingBottom: '10px !important',
              maxHeight: '180px',
              borderRadius: '16px'
            }}>
            <Row gutter={24}>
              <Col span={14}>
                <Paragraph style={{ fontSize: '16px' }} type="secondary">Cuentas activas</Paragraph>
                <Title level={2} style={{ marginLeft: '0px', marginTop: '0px' }}>{ platformData?.cardholders?.actives }</Title>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'start', width: '100%' }}>
                  <RiseOutlined
                    style={{
                      fontSize: '25px',
                      width: '40px',
                      height: '40px',
                      justifyContent: 'center',
                      color: 'rgb(105, 80, 232)',
                      backgroundColor: 'rgba(105, 80, 232, 0.1)',
                      borderRadius: '50%',
                    }} />
                  <Typography.Text style={{ paddingLeft: '5px' }}>
                    {
                      (Math.round((platformData?.cardholders?.new_actives / platformData?.cardholders?.actives) * 100) > 0) ? `+ ${Math.round((platformData?.cardholders?.new_actives / platformData?.cardholders?.actives) * 100)}% Inc` : ''
                    }
                  </Typography.Text>
                </div>
              </Col>
              <Col span={10}>
                <ActiveAccountsChart
                  accounts = { platformData?.cardholders }
                />
              </Col>
            </Row>
          </Card>
        </Col>

        <Col span={24} style={{ paddingLeft: '0px' }}>
          <Card
            loading={loading}
            style={{
              paddingBottom: '10px !important',
              maxHeight: '180px',
              borderRadius: '16px'
            }}>
            <Row gutter={24}>
              <Col span={14}>
                <Paragraph style={{ fontSize: '16px' }} type="secondary">Cuentas inactivas</Paragraph>
                <Title level={2} style={{ marginLeft: '0px', marginTop: '0px' }}>{ platformData?.cardholders?.inactives || 0 }</Title>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'start', width: '100%' }}>
                  <FallOutlined
                    style={{
                      fontSize: '25px',
                      width: '40px',
                      height: '40px',
                      justifyContent: 'center',
                      color: 'rgb(105, 80, 232)',
                      backgroundColor: 'rgba(105, 80, 232, 0.1)',
                      borderRadius: '50%',
                    }} />
                  <Typography.Text style={{ paddingLeft: '5px' }}>
                    {
                      (Math.round((platformData?.cardholders?.new_inactives / platformData?.cardholders?.inactives) * 100) > 0) ? `+ ${Math.round((platformData?.cardholders?.new_inactives / platformData?.cardholders?.inactives) * 100)}% Dec` : ''
                    }
                  </Typography.Text>
                </div>
              </Col>
              <Col span={10}>
                <InactiveAccountsChart
                  accounts = { platformData?.cardholders }
                />
              </Col>
            </Row>
          </Card>
        </Col>
      </Col>
    ) :(
    <Row gutter={24} style={{ marginTop: '2rem' }}>
      <Col span={8}>
        <Card
          loading={loading}
          style={{
            paddingBottom: '10px !important',
            maxHeight: '180px',
            borderRadius: '16px'
          }}>
          <Row gutter={24}>
            <Col span={14}>
              <Paragraph style={{ fontSize: '16px' }} type="secondary">Cards nuevas</Paragraph>
              <Title level={2} style={{ marginLeft: '0px', marginTop: '0px' }}>{ platformData?.cards?.created || 0 }</Title>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'start', width: '100%' }}>
                <CreditCardOutlined
                  style={{
                    fontSize: '25px',
                    width: '40px',
                    height: '40px',
                    justifyContent: 'center',
                    color: 'rgb(105, 80, 232)',
                    backgroundColor: 'rgba(105, 80, 232, 0.1)',
                    borderRadius: '50%',
                  }} />
                <Typography.Text style={{ paddingLeft: '5px' }}>
                  + { Math.round((platformData?.cards?.created / platformData?.cards?.total) * 100) }%
                </Typography.Text>
              </div>
            </Col>
            <Col span={10}>
              <NewCardsChart
                totalCards={ platformData?.cards?.total }
                createdCards={ platformData?.cards?.created }
              />
            </Col>
          </Row>
        </Card>
      </Col>

      <Col
        span={8}
      >
        <Card
          loading={loading}
          style={{
            paddingBottom: '10px !important',
            maxHeight: '180px',
            borderRadius: '16px'
          }}>
          <Row gutter={24}>
            <Col span={14}>
              <Paragraph style={{ fontSize: '16px' }} type="secondary">Cuentas activas</Paragraph>
              <Title level={2} style={{ marginLeft: '0px', marginTop: '0px' }}>{ platformData?.cardholders?.actives || 0 }</Title>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'start', width: '100%' }}>
                <RiseOutlined
                  style={{
                    fontSize: '25px',
                    width: '40px',
                    height: '40px',
                    justifyContent: 'center',
                    color: 'rgb(105, 80, 232)',
                    backgroundColor: 'rgba(105, 80, 232, 0.1)',
                    borderRadius: '50%',
                  }} />
                <Typography.Text style={{ paddingLeft: '5px' }}>
                  {
                    (Math.round((platformData?.cardholders?.new_actives / platformData?.cardholders?.actives) * 100) > 0) ? `+ ${Math.round((platformData?.cardholders?.new_actives / platformData?.cardholders?.actives) * 100)}% Inc` : ''
                  }
                </Typography.Text>
              </div>
            </Col>
            <Col span={10}>
              <ActiveAccountsChart
                accounts = { platformData?.cardholders }
              />
            </Col>
          </Row>
        </Card>
      </Col>

      <Col span={8}>
        <Card
          loading={loading}
          style={{
            paddingBottom: '10px !important',
            maxHeight: '180px',
            borderRadius: '16px'
          }}>
          <Row gutter={24}>
            <Col span={14}>
              <Paragraph style={{ fontSize: '16px' }} type="secondary">Cuentas inactivas</Paragraph>
              <Title level={2} style={{ marginLeft: '0px', marginTop: '0px' }}>{ platformData?.cardholders?.inactives || 0 }</Title>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'start', width: '100%' }}>
                <FallOutlined
                  style={{
                    fontSize: '25px',
                    width: '40px',
                    height: '40px',
                    justifyContent: 'center',
                    color: 'rgb(105, 80, 232)',
                    backgroundColor: 'rgba(105, 80, 232, 0.1)',
                    borderRadius: '50%',
                  }} />
                <Typography.Text style={{ paddingLeft: '5px' }}>
                  {
                    (Math.round((platformData?.cardholders?.new_inactives / platformData?.cardholders?.inactives) * 100) > 0) ? `+ ${Math.round((platformData?.cardholders?.new_inactives / platformData?.cardholders?.inactives) * 100)}% Dec` : ''
                  }
                </Typography.Text>
              </div>
            </Col>
            <Col span={10}>
              <InactiveAccountsChart
                accounts = { platformData?.cardholders }
              />
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
  )
}

export default DataMiddleCards;